import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { createFilterOptions, useSnackbar, Autocomplete, Button, Stack, Typography } from '@emburse/embark-core';
import { useCallback, useEffect, useState } from 'react';
import { $t } from '../../../../hooks/useTranslation';
export default function ExceptionManager({ auditDefPayload, exceptionDetailType, fetchOptions, getOptionLabel, addExceptions, refreshExceptionDetails, label, exceptionDetails }) {
    const { enqueueSnackbar } = useSnackbar();
    const [selectedOptions, setSelectedOptions] = useState([]);
    const [requestedOptions, setRequestedOptions] = useState([]);
    const [options, setOptions] = useState([]);
    const [loading, setLoading] = useState(true);
    const exceptionManagerFilterOptions = createFilterOptions({
        limit: 100
    });
    const updateFilteredOptions = useCallback(async () => {
        const filteredOptions = requestedOptions.filter((option) => !exceptionDetails.some((exception) => exception.TypeID === option.PK));
        setOptions(filteredOptions);
    }, [exceptionDetails, requestedOptions]);
    const fetchInitialOptions = useCallback(async () => {
        try {
            const fetchedOptions = await fetchOptions();
            setRequestedOptions(() => fetchedOptions);
            await updateFilteredOptions();
        }
        catch (error) {
            enqueueSnackbar($t('Error fetching options'), { variant: 'error' });
        }
        finally {
            setLoading(false);
        }
    }, [enqueueSnackbar, fetchOptions, updateFilteredOptions]);
    useEffect(() => {
        (async () => {
            if (!loading) {
                await updateFilteredOptions();
            }
            else {
                await fetchInitialOptions();
            }
        })();
    }, [fetchInitialOptions, loading, updateFilteredOptions]);
    return (_jsxs(Stack, { alignItems: "center", direction: "row", spacing: 1, sx: { width: '100%' }, children: [_jsx(Autocomplete, { value: selectedOptions, options: options, getOptionLabel: getOptionLabel, label: loading ? $t('Loading...') : $t(label), sx: { width: '280px' }, onChange: (_event, value) => {
                    setSelectedOptions(value);
                }, disabled: loading, disableCloseOnSelect: true, multiple: true, "data-qa": "exception-autocomplete", filterOptions: exceptionManagerFilterOptions }), _jsx(Button, { variant: "outlined", sx: { width: '80px' }, disabled: selectedOptions.length === 0 || loading, onClick: async () => {
                    try {
                        await addExceptions({
                            AuditDefPK: auditDefPayload.AuditDefPK,
                            ExceptionType: exceptionDetailType,
                            ExceptionIDs: selectedOptions.map((option) => option.PK)
                        });
                        setSelectedOptions([]);
                        await refreshExceptionDetails();
                        enqueueSnackbar($t('Exceptions added successfully'), {
                            variant: 'success'
                        });
                    }
                    catch (error) {
                        enqueueSnackbar($t('Error adding exception'), { variant: 'error' });
                    }
                }, "data-qa": "add-exception-button", children: _jsx(Typography, { color: "inherit", children: $t('Add') }) })] }));
}
